import React, { useEffect, useRef } from 'react';
import { ChevronRight } from '@yme/assets/icons';
import { StepIcon } from './StepIcon';
import { getIconState } from './helpers';
import { StepStyled, StepTextStyled, StepWrapperStyled } from './styled';
export function Step({ id, element, stepConditions, isRightToLeft, stepsWidthArray, }) {
    const iconState = getIconState(stepConditions);
    const isNextStep = !stepConditions.isCurrent && !stepConditions.isPassed;
    const ref = useRef(null);
    useEffect(() => {
        if (ref?.current) {
            const absolutePathOfElementWidth = 10;
            stepsWidthArray.push(ref.current.clientWidth + absolutePathOfElementWidth);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref]);
    return (React.createElement(StepStyled, { id: id, ref: element, isRightToLeft: isRightToLeft },
        React.createElement(StepWrapperStyled, { ref: ref },
            React.createElement(StepIcon, { iconState: iconState, stepNumber: stepConditions.number, isRightToLeft: isRightToLeft }),
            React.createElement(StepTextStyled, { isRightToLeft: isRightToLeft, number: stepConditions.number, iconUrl: ChevronRight, isNextStep: isNextStep }, stepConditions.title))));
}
